import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import tacomaImage from '../images/tacoma.jpg';

function Home() {
  return (
    <>
      <Helmet>
        <title>Tacoma Off Market - We Buy Houses Fast For Cash | No Fees, No Repairs</title>
        <meta name="description" content="Sell your Tacoma house fast for cash. No repairs needed, no realtor fees, no closing costs. Get a fair cash offer within 24 hours from local investors." />
      </Helmet>
      
      <div className="min-h-screen">
        <div className="relative">
          {/* Background image with gradient overlay */}
          <div 
            className="absolute inset-0 z-0"
            style={{
              backgroundImage: `url(${tacomaImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          />
          {/* Gradient overlay */}
          <div 
            className="absolute inset-0 z-0"
            style={{
              background: 'linear-gradient(to left, rgba(132, 204, 22, 0.85) 0%, rgba(22, 163, 74, 0.8) 10%, rgba(22, 163, 74, 0.7) 25%, rgba(22, 163, 74, 0.6) 40%, rgba(22, 163, 74, 0.45) 55%, rgba(22, 163, 74, 0.3) 70%, rgba(22, 163, 74, 0.15) 85%, transparent 95%)'
            }}
          />
          
          {/* Content */}
          <div className="relative z-10 bg-transparent text-white py-20">
            <div className="container mx-auto text-center">
              <h1 
                className="text-5xl font-bold mb-6"
                style={{
                  textShadow: `-1px -1px 0 rgba(22, 163, 74, 0.7), 1px -1px 0 rgba(22, 163, 74, 0.7), -1px 1px 0 rgba(22, 163, 74, 0.7), 1px 1px 0 rgba(22, 163, 74, 0.7), 0 0 15px rgba(22, 163, 74, 0.5)`
                }}
              >
                Sell Your Tacoma House Fast
              </h1>
              <p 
                className="text-xl mb-8"
                style={{
                  textShadow: `-1px -1px 0 rgba(22, 163, 74, 0.7), 1px -1px 0 rgba(22, 163, 74, 0.7), -1px 1px 0 rgba(22, 163, 74, 0.7), 1px 1px 0 rgba(22, 163, 74, 0.7), 0 0 10px rgba(22, 163, 74, 0.5)`
                }}
              >
                Get a fair cash offer within 24 hours
              </p>
              <Link 
                to="/contact" 
                className="inline-block px-8 py-4 text-center bg-green-500 hover:bg-green-600 text-white font-bold rounded-md transition duration-300 shadow-lg"
              >
                Get My Cash Offer
              </Link>
            </div>
          </div>
        </div>
        
        <div className="container mx-auto py-16">
          <h2 className="text-3xl font-bold text-center mb-10 text-green-700">Why Sell To Us?</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6 border border-gray-100 rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-2xl font-bold mb-4 text-green-600">Fast Closing</h3>
              <p>We will work within your timeline. Close in as little as 7 days.</p>
            </div>
            <div className="text-center p-6 border border-gray-100 rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-2xl font-bold mb-4 text-green-600">No Repairs Needed</h3>
              <p>Sell your house as-is, we handle all repairs no matter the condition.</p>
            </div>
            <div className="text-center p-6 border border-gray-100 rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <h3 className="text-2xl font-bold mb-4 text-green-600">No Fees</h3>
              <p>No real estate commissions or closing costs. Keep more money in your pocket.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home; 